import type { PricingTier } from '../types/content'

export const pricingTiers: PricingTier[] = [
  {
    name: 'Starter',
    price: '₹ 15,000',
    cadence: 'fixed price · 3 weeks',
    summary: 'One to three pages that do one job: turn attention into an enquiry.',
    bestFor: 'Launching a product or testing a new offer',
    pageRange: '1 to 3 Pages',
    includedItems: [
      '1–3 custom pages',
      'Brand and visual direction',
      'CMS setup',
      'Basic SEO and analytics',
      'Feedback rounds agreed in the Scope of Work',
    ],
    ctaLabel: 'Start a project',
    ctaVariant: 'primary',
  },
  {
    name: 'Standard',
    price: '₹ 25,000',
    cadence: 'fixed price · 3–4 weeks',
    summary: 'Four to six pages, designed and built with a CMS your team can run.',
    bestFor: 'Small companies replacing a site they have outgrown',
    pageRange: '4 to 6 Pages',
    includedItems: [
      '4–6 custom pages',
      'Brand and visual direction',
      'CMS setup',
      'Basic SEO and analytics',
      'Feedback rounds agreed in the Scope of Work',
    ],
    ctaLabel: 'Start a project',
    ctaVariant: 'primary',
    highlighted: true,
  },
  {
    name: 'Custom',
    price: 'Quoted on Scope',
    cadence: 'quoted after a scoping call',
    summary: 'Seven pages or more, e-commerce, or a system several teams will edit.',
    bestFor: 'Larger sites, storefronts and multi-team content',
    pageRange: '7+ Pages & Systems',
    includedItems: [
      '7+ custom pages',
      'Brand and visual direction',
      'CMS setup',
      'Basic SEO and analytics',
      'Feedback rounds agreed in the Scope of Work',
    ],
    ctaLabel: 'Contact us',
    ctaVariant: 'secondary',
  },
]
